import { AxiosError } from 'axios';
import { QueryConfig, useQuery } from 'react-query';

import { DbProject } from '~src/types/db';
import { getProjectsList } from '~src/services/api';
import { DEFAULT_REACT_QUERY_STALE_TIME } from '~src/config';

const FIVE_MINUTES = 5 * 60 * 1000;

const shouldRetry = (err: any) => {
  const status = err?.response?.status;
  if (status === 401 || status === 403) return false;
  return true;
};

export const useProjectList = (
  queryConfig: QueryConfig<DbProject[], AxiosError> & { enabled?: boolean } = {}
) => {
  const { enabled, ...options } = queryConfig;
  // if enabled = undefined then enabled = true
  const enabledOverwrite = enabled || enabled === undefined;

  const projectQuery = useQuery<DbProject[], AxiosError>(
    ['projectList'],
    getProjectsList,
    {
      enabled: enabledOverwrite,

      refetchOnWindowFocus: false,
      refetchOnMount: false,
      staleTime: Math.max(DEFAULT_REACT_QUERY_STALE_TIME ?? 0, FIVE_MINUTES),
      refetchInterval: FIVE_MINUTES,

      retry: (failureCount: number, err: any) => {
        if (!shouldRetry(err)) return false;
        return failureCount < 2;
      },

      ...options,
    }
  );

  return {
    ...projectQuery,
    data: projectQuery.data?.sort((a, b) => a.name.localeCompare(b.name)),
  };
};
